import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Testimonials from "@/pages/Testimonials";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/components/AdminLayout";
import AdminPosts from "@/pages/admin/AdminPosts";
import AdminPostEditor from "@/pages/admin/AdminPostEditor";
import AdminNewsletters from "@/pages/admin/AdminNewsletters";
import AdminNewsletterEditor from "@/pages/admin/AdminNewsletterEditor";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public site */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/testimonials" element={<Testimonials />} />
          </Route>

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminPosts />} />
              <Route path="/admin/new" element={<AdminPostEditor />} />
              <Route path="/admin/edit/:id" element={<AdminPostEditor />} />
              <Route path="/admin/newsletter" element={<AdminNewsletters />} />
              <Route path="/admin/newsletter/new" element={<AdminNewsletterEditor />} />
              <Route path="/admin/newsletter/edit/:id" element={<AdminNewsletterEditor />} />
              <Route path="/admin/subscribers" element={<AdminSubscribers />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#1A0F2E",
            color: "#FDFBF7",
            border: "1px solid #8B5CF6",
            borderRadius: "8px",
            fontFamily: "IBM Plex Sans",
          },
        }}
      />
    </div>
  );
}

export default App;
